import { UseFormRegisterReturn } from 'react-hook-form';

/** 属性定義 */
type Props = {
  name: string;
  id: string;
  className?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  register?: UseFormRegisterReturn;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtPasswordBox = ({
  name,
  id,
  className,
  defaultValue,
  placeholder,
  disabled,
  maxLength,
  minLength,
  register
}: Props) => {
  return <input type='password' className={`atpasswordbox ${className}`} name={name} id={id} defaultValue={defaultValue} placeholder={placeholder} disabled={disabled} maxLength={maxLength} minLength={minLength} {...register} />;
};
/** 初期値の設定 */
AtPasswordBox.defaultProps = {
  className: '',
  defaultValue: null,
  placeholder: null,
  disabled: false,
  maxLength: null,
  minLength: null,
  register: null
};
export default AtPasswordBox;